import { useSelector } from 'react-redux';
import { selectPromotions } from '../../selectors/builder';
import { Section } from '../../components/Section';
import * as React from 'react';
import { Promotions } from '../../components/Promotions';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { useDeviceType } from '@cian/ui-kit';
import { CallButtonContainer } from '../CallButtonContainer';

export const PromotionsContainer = () => {
  const promotions = useSelector(selectPromotions);
  const deviceType = useDeviceType();

  const phoneButton = React.useMemo(
    () =>
      deviceType === 'phone' ? (
        <CallButtonContainer />
      ) : (
        <PhoneButtonContainer text="Показать контакты" withIcon size="L" />
      ),
    [deviceType],
  );

  if (!promotions.length) {
    return null;
  }

  return (
    <Section dataName="Promotions" fullWidth>
      <Promotions items={promotions} phoneButton={phoneButton} />
    </Section>
  );
};
